import { createContainer, createHook, createStore } from 'react-sweet-state';

// TODO: This export service should be made generic and then moved to 'proforma[-jira]-export'
//       so that it can be used in this package, Jira issue view, and Jira issue search (possibly others).

const spreadsheetPollMaximumDelay = 5000; // 5000ms = five seconds
const spreadsheetPollMultiplier = 1.2; // 1.2x = increase wait time by 20% for each poll

const initialState = {
  formId: undefined,
  filename: undefined,
  serverProgress: undefined,
  taskId: undefined,
  // For internal use only.
  pollDelay: 500,
  // For internal use only. // 500ms = half a second
  timeoutHandle: undefined,
  // For internal use only.
  downloading: false,
  successful: false,
  error: false
};
const actions = {
  start: form => ({
    setState,
    getState,
    dispatch
  }, {
    errorUtils,
    projectFormApi
  }) => {
    if (getState().filename) {
      return false;
    }
    setState({
      formId: form.id,
      filename: `${form.name}.xlsx`
    });
    projectFormApi.startXlsxDownload(form.id).then(xlsxDownloadTask => {
      if (xlsxDownloadTask) {
        setState({
          serverProgress: 0,
          taskId: xlsxDownloadTask.id
        });
      }
      dispatch(processXlsxDownloadResponse(xlsxDownloadTask));
    }).catch(() => {
      errorUtils.reportError(new Error('The XLSX download task failed while starting.'));
      setState({
        error: true
      });
    });
    // NOTE: Analytics should probably be re-added here.
    return true;
  },
  clear: () => ({
    setState,
    getState
  }) => {
    window.clearTimeout(getState().timeoutHandle);
    setState(initialState);
  }
};
const Store = createStore({
  initialState,
  actions,
  name: 'ExportStore'
});
export const ExportContainer = createContainer(Store);
export const useExportController = createHook(Store);
const processXlsxDownloadResponse = xlsxDownloadTask => ({
  setState,
  getState,
  dispatch
}) => {
  if (xlsxDownloadTask.status.failed) {
    setState({
      error: true
    });
  } else if (xlsxDownloadTask.status.complete) {
    setState({
      serverProgress: 100
    });
    dispatch(downloadXlsx());
  } else {
    const state = getState();
    setState({
      serverProgress: xlsxDownloadTask.status.progress,
      pollDelay: Math.min(state.pollDelay * spreadsheetPollMultiplier, spreadsheetPollMaximumDelay),
      timeoutHandle: window.setTimeout(() => dispatch(checkXlsxDownload()), state.pollDelay)
    });
  }
};
const checkXlsxDownload = () => ({
  setState,
  getState,
  dispatch
}, {
  errorUtils,
  projectFormApi
}) => {
  const {
    formId,
    taskId
  } = getState();
  if (formId === undefined || taskId === undefined) {
    errorUtils.reportError(new Error('Cannot check XLSX download, the download form or task ID is undefined.'));
    setState({
      error: true
    });
    return;
  }
  projectFormApi.checkXlsxDownload(formId, taskId).then(xlsxDownloadTask => dispatch(processXlsxDownloadResponse(xlsxDownloadTask))).catch(() => {
    errorUtils.reportError(new Error('The XLSX download task failed while checking progress.'));
    setState({
      error: true
    });
  });
};
const downloadXlsx = () => ({
  setState,
  getState
}, {
  errorUtils,
  projectFormApi
}) => {
  const {
    formId,
    filename,
    taskId
  } = getState();
  if (formId === undefined || filename === undefined || taskId === undefined) {
    errorUtils.reportError(new Error('Cannot finish XLSX download, a required property is undefined.'));
    setState({
      error: true
    });
    return;
  }
  setState({
    downloading: true
  });
  projectFormApi.downloadFinishedXlsx(formId, taskId).then(xlsxBlob => {
    const downloadLink = window.document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(xlsxBlob);
    downloadLink.setAttribute('download', filename);
    window.document.body.appendChild(downloadLink);
    downloadLink.click();
    window.document.body.removeChild(downloadLink);
    setState({
      downloading: false,
      successful: true
    });
  }).catch(() => {
    errorUtils.reportError(new Error('The XLSX download task failed while downloading.'));
    setState({
      error: true
    });
  });
};